import { Card, CardBody, Col } from "reactstrap";
import OffsetLeft from "./OffsetLeft";
import OffsetRight from "./OffsetRight";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { PopoverOffsetTitle } from "../../../../Constants/Constants";
import { PopoverOffsetSubTitle } from "../../../../Data/UiKits/Popover";

const PopoverOffset = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={PopoverOffsetTitle} span={PopoverOffsetSubTitle} />
        <CardBody className="common-flex popover-wrapper">
          <OffsetRight />
          <OffsetLeft />
        </CardBody>
      </Card>
    </Col>
  );
};
export default PopoverOffset